import zetsubo01 from "../image/themes/Z001.png"
import zetsubo02 from "../image/themes/Z002.png";
import zetsubo03 from "../image/themes/Z003.png";
import zetsubo04 from "../image/themes/Z004.png";
import zetsubo05 from "../image/themes/Z005.png";
import zetsubo06 from "../image/themes/Z006.png";
import zetsubo07 from "../image/themes/Z007.png";
import zetsubo08 from "../image/themes/Z008.png";
import zetsubo09 from "../image/themes/Z009.png";
import zetsubo10 from "../image/themes/Z010.png";
import zetsubo11 from "../image/themes/Z011.png";
import zetsubo12 from "../image/themes/Z012.png";
import zetsubo13 from "../image/themes/Z013.png";
import zetsubo14 from "../image/themes/Z014.png";
import zetsubo15 from "../image/themes/Z015.png";
import zetsubo16 from "../image/themes/Z016.png";
import zetsubo17 from "../image/themes/Z017.png";
import zetsubo18 from "../image/themes/Z018.png";
import zetsubo19 from "../image/themes/Z019.png";
import zetsubo20 from "../image/themes/Z020.png";
import zetsubo21 from "../image/themes/Z021.png";
import zetsubo22 from "../image/themes/Z022.png";
import zetsubo23 from "../image/themes/Z023.png";
import zetsubo24 from "../image/themes/Z024.png";
import zetsubo25 from "../image/themes/Z025.png";
import zetsubo26 from "../image/themes/Z026.png";
import zetsubo27 from "../image/themes/Z027.png";
import zetsubo28 from "../image/themes/Z028.png";
import zetsubo29 from "../image/themes/Z029.png";
import zetsubo30 from "../image/themes/Z030.png";

type themes = {
	[key: string]: string;
};

export const zetsuboNameList = [
	"zetsubo01",
	"zetsubo02",
	"zetsubo03",
	"zetsubo04",
	"zetsubo05",
	"zetsubo06",
	"zetsubo07",
	"zetsubo08",
	"zetsubo09",
	"zetsubo10",
	"zetsubo11",
	"zetsubo12",
	"zetsubo13",
	"zetsubo14",
	"zetsubo15",
	"zetsubo16",
	"zetsubo17",
	"zetsubo18",
	"zetsubo19",
	"zetsubo20",
	"zetsubo21",
	"zetsubo22",
	"zetsubo23",
	"zetsubo24",
	"zetsubo25",
	"zetsubo26",
	"zetsubo27",
	"zetsubo28",
	"zetsubo29",
	"zetsubo30",
];

const zetsuboList: themes = {
	zetsubo01: zetsubo01,
	zetsubo02: zetsubo02,
	zetsubo03: zetsubo03,
	zetsubo04: zetsubo04,
	zetsubo05: zetsubo05,
	zetsubo06: zetsubo06,
	zetsubo07: zetsubo07,
	zetsubo08: zetsubo08,
	zetsubo09: zetsubo09,
	zetsubo10: zetsubo10,
	zetsubo11: zetsubo11,
	zetsubo12: zetsubo12,
	zetsubo13: zetsubo13,
	zetsubo14: zetsubo14,
	zetsubo15: zetsubo15,
	zetsubo16: zetsubo16,
	zetsubo17: zetsubo17,
	zetsubo18: zetsubo18,
	zetsubo19: zetsubo19,
	zetsubo20: zetsubo20,
	zetsubo21: zetsubo21,
	zetsubo22: zetsubo22,
	zetsubo23: zetsubo23,
	zetsubo24: zetsubo24,
	zetsubo25: zetsubo25,
	zetsubo26: zetsubo26,
	zetsubo27: zetsubo27,
	zetsubo28: zetsubo28,
	zetsubo29: zetsubo29,
	zetsubo30: zetsubo30,
};

export const getZetsuboFile = (name: string): string => {
	return zetsuboList[name];
};
